import { render, staticRenderFns } from "./dashboard-layout.vue?vue&type=template&id=5c20594e"
import script from "./dashboard-layout.vue?vue&type=script&lang=js"
export * from "./dashboard-layout.vue?vue&type=script&lang=js"
import style0 from "./dashboard-layout.vue?vue&type=style&index=0&id=5c20594e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports